import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';
import { fieldAnomaly } from '../../../../../utils/formatter';
import { checkSearch, formatListData } from '../../../common/commons';

export default class MainClientChange extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.title = '前五名客户情况';
        this.rowKey = 'rowNum';
    }

    getColumns = () => {
        let year = checkSearch().reportYear;
        return [{
            title: year,
            dataIndex: 'customerName',
            render: fieldAnomaly
        }, {
            title: '销售额',
            dataIndex: 'customerAmout',
            render: fieldAnomaly
        }, {
            title: year - 1,
            dataIndex: 'name',
            render: fieldAnomaly
        }, {
            title: '销售额',
            dataIndex: 'amout',
            render: fieldAnomaly
        }];
    };

    formatResponse = (data) => {
        data = data || {};
        return {
            data: formatListData(data.customerList, 'customer')
        };
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialFraudAnalysis/subComponents/details/MainClientChange.jsx